import React, { useState, useRef } from "react";
import { Table, Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./style.css";

const GenericTable = ({
  title,
  dataSource,
  columns,
  onRowClick,
  loading = false,
  pagination,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const searchInput = useRef(null);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const enhancedColumns = columns.map((col) => {
    if (col.enableSearch) {
      return { ...col, ...getColumnSearchProps(col.dataIndex) };
    }
    return col;
  });

  return (
    <div className="table-generic">
      <div className="title">{title}</div>
      <Table
        loading={loading}
        dataSource={dataSource}
        columns={enhancedColumns}
        rowKey={(record, index) => record.key || index}
        pagination={pagination || { pageSize: 10 }}
        rowSelection={rowSelection}
        onRow={(record) => ({
          onClick: () => {
            onRowClick(record);
          },
        })}
        bordered
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default GenericTable;
